import $ from "jquery";
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollSmoother } from "gsap/dist/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

function progressIndicator() {
  // Section progress indicator
  const prefix = "";
  const rotate = "rotate3d(0,0,1,";

  $(window).scroll(function () {
    const top = $(this).scrollTop();

    // Calculate each progress section
    $("section").each(function (i) {
      const thisTop = $(this).offset().top - 20;
      const height = $(this).height();
      const thisBottom = thisTop + height;
      let percent = 0;

      // Scrolled within current section
      if (top >= thisTop && top <= thisBottom) {
        if (i + 1 === $("section").length) {
          percent =
            ((top - thisTop) /
              ($(document).height() - $(window).height() - thisTop)) *
            100;
        } else {
          percent = ((top - thisTop) / height) * 100;
        }

        if (percent >= 100) {
          percent = 100;
        }
      } else if (top > thisBottom) {
        percent = 100;
      }

      // Adds the active class
      if (percent < 100 && percent > 0) {
        if (!$(".circle:eq(" + i + ")").hasClass("is-active")) {
          $(".circle:eq(" + i + ")").toggleClass("is-active");
        }
      } else {
        $(".circle:eq(" + i + ")").removeClass("is-active");
      }

      // "Fills" the circles
      if (percent <= 50) {
        $(".mask-right .fill:eq(" + i + ")").css(
          prefix + "transform",
          rotate + (360 * percent) / 100 + "deg)",
        );
        $(".mask-left .fill:eq(" + i + ")").css(
          prefix + "transform",
          rotate + "0)",
        );
      } else if (percent > 50) {
        $(".mask-left .fill:eq(" + i + ")").css(
          prefix + "transform",
          rotate + ((360 * percent) / 100 - 180) * 1 + "deg)",
        );
        $(".mask-right .fill:eq(" + i + ")").css(
          prefix + "transform",
          rotate + "180deg)",
        );
      }
    });
  });
}

const isLandingPage = document.querySelector(".landing-page") as HTMLElement;

if (isLandingPage) {
  const smoother = ScrollSmoother.create({
    content: "#content",
    effects: false,
    smooth: 0,
    wrapper: "#wrapper",
  });

  gsap.utils.toArray(".panel").forEach((panel, index) => {
    const shapes = panel.querySelectorAll(".shape");

    if (shapes) {
      shapes.forEach((shape, i) => {
        const xSetter = gsap.utils.pipe(
          gsap.utils.clamp(-70, 70),
          gsap.quickSetter(shape, "x", "px"), // apply it to the #id element's x property and append a "px" unit
        );

        const ySetter = gsap.utils.pipe(
          gsap.utils.clamp(-1000, 1000),
          gsap.quickSetter(shape, "y", "px"), // apply it to the #id element's x property and append a "px" unit
        );

        const shapeOffset = smoother.offset(shape, "top 80%");
        const ySpeed = shape.dataset.yspeed;
        const xSpeed = shape.dataset.xspeed;

        ScrollTrigger.create({
          end: "bottom top",
          onUpdate: (self) => {
            ySetter((self.scroll() - shapeOffset) * ySpeed);
            xSetter((self.scroll() - shapeOffset) * xSpeed);
          },
          scrub: 1,
          start: "top 80%",
          trigger: shape,
        });
      });
    }
  });

  // Progress indicator
  let eventFired = 0;

  if ($(window).width() >= 1024) {
    eventFired = 1;
    progressIndicator();
  }

  $(window).on("resize", () => {
    if (!eventFired) {
      if ($(window).width() < 1024) {
        eventFired = 0;
      } else {
        eventFired = 1;
        progressIndicator();
      }
    }
  });
}
